import type { SendEmailRequest } from '../lib/payloads/sendEmail';
import type { SendEmailResponse } from '../lib/responses/sendEmail';
import { post } from './baseUrl';
import { ApiEndpoint } from './endpoints';

export const sendEmail = async (
  request: SendEmailRequest,
): Promise<SendEmailResponse> => {
  const response = await post(ApiEndpoint.sendEmail, request);
  return (response.data ?? {}) as SendEmailResponse;
};
